import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { User } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ProfileUpdateDataServiceProvider } from '@web-services/profile/profile-update.data.service';
import { ProfileUpdateServiceProvider } from '@web-services/profile/profile-update.service';
import { AccountServiceWebProvider } from '@web-services/user/account.service';
import { finalize, switchMap, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'login-change',
	template: require('./login-change.html'),
	styles: [require('./login-change.scss')]
})
export class LoginChangeComponent {
	@Input() user: User;
	@Input() initialEmail: string;
	@Output() onUserMailChange: EventEmitter<void> = new EventEmitter();

	disableButton: boolean;
	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private messageService: MessageService,
		private profileUpdateService: ProfileUpdateDataServiceProvider,
		private profileService: ProfileUpdateServiceProvider,
		private accountService: AccountServiceWebProvider
	) {}

	changeEmail(): void {
		if (this.profileService.isValidEmail(this.user.email, this.initialEmail)) {
			this.disableButton = true;

			this.profileUpdateService
				.changeUserEmail(this.user.email)
				.pipe(
					takeUntil(this.unsubscribe),
					switchMap(() => this.accountService.getUserWeb()),
					finalize(() => (this.disableButton = false))
				)
				.subscribe(
					(data: User): void => this.successChangeUserEmail(data),
					error =>
						this.messageService.showErrorFromBackend(
							'Sorry!',
							error.data.errorMessage
						)
				);
		}
	}

	private successChangeUserEmail(data: User): void {
		this.onUserMailChange.emit();
		this.messageService.showToaster('s_2', 'profile');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/profile/login-change/login-change.ts